import { render } from "./PageUploadFileSurat.vue?vue&type=template&id=d91253c4"
import script from "./PageUploadFileSurat.vue?vue&type=script&lang=js"
export * from "./PageUploadFileSurat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__